import { render, staticRenderFns } from "./RegularForms.vue?vue&type=template&id=6a56b325&scoped=true&"
import script from "./RegularForms.vue?vue&type=script&lang=js&"
export * from "./RegularForms.vue?vue&type=script&lang=js&"
import style0 from "./RegularForms.vue?vue&type=style&index=0&id=6a56b325&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a56b325",
  null
  
)

export default component.exports